import { Text } from "@sembark-travel/ui-base"
import { ICabType } from "./store"
import { EntryTypeIcon } from "../shared/EntryTypeConfig"

type IShowCabCapacityInfoProps = {
	cabType: Pick<
		ICabType,
		"capacity" | "capacity_child_age_limit" | "entry_type"
	>
	color?: React.ComponentProps<typeof Text>["color"]
	showEntryType?: boolean
}

export function ShowCabCapacityInfo({
	cabType,
	color = "muted",
	showEntryType = false,
}: IShowCabCapacityInfoProps) {
	const { capacity, capacity_child_age_limit, entry_type } = cabType
	return (
		<Text fontSize="sm" color={color}>
			{cabType.capacity ? (
				<>
					Cap: {capacity} Pax
					{capacity_child_age_limit
						? ` & C.age> ${capacity_child_age_limit}y`
						: null}{" "}
				</>
			) : null}
			{showEntryType ? <EntryTypeIcon entryType={entry_type} /> : null}
		</Text>
	)
}
